import { NabanApi } from '@izimi/api';
import { createNabanModule } from '@izimi/modules';
import { fetchService } from 'core/services/fetchService';

const nabanModule = createNabanModule({ nabanApi: new NabanApi(fetchService) });

export const useGetNabanAuthenticationModes = nabanModule.useGetNabanAuthenticationModes;
export const useDownloadNabanDeedDocument = nabanModule.useDownloadNabanDeedDocument;
